import { render, staticRenderFns } from "./componentsLoader.vue?vue&type=template&id=3e40bbe6&"
import script from "./componentsLoader.vue?vue&type=script&lang=js&"
export * from "./componentsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports